import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { createStyles, rem, keyframes } from '@mantine/styles';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var fade = keyframes({
  "from, to": {
    opacity: 0.4
  },
  "50%": {
    opacity: 1
  }
});
var useStyles = createStyles(function (theme, _ref) {
  var height = _ref.height,
      width = _ref.width,
      radius = _ref.radius,
      circle = _ref.circle,
      animate = _ref.animate;
  return {
    root: {
      height: rem(height),
      width: circle ? rem(height) : rem(width),
      borderRadius: circle ? rem(height) : theme.fn.radius(radius),
      position: "relative",
      WebkitTransform: "translateZ(0)"
    },
    visible: {
      overflow: "hidden",
      "&::before": __spreadProps(__spreadValues({}, theme.fn.cover(0)), {
        content: '""',
        background: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
        zIndex: 10
      }),
      "&::after": __spreadProps(__spreadValues({}, theme.fn.cover(0)), {
        content: '""',
        background: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3],
        animation: animate ? "".concat(fade, " 1500ms linear infinite") : "none",
        zIndex: 11
      })
    }
  };
});
export default useStyles;
export { fade };